<template>
    <keep-alive>
        <router-view/>
    </keep-alive>
</template>

<script>
    export default {
        name: "Creator_EditQuests"
    }
</script>

<style scoped>

</style>